<!-- Main Page Start -->
<div class="content-wrapper table-full-bx">
  <div class="page-content graphs">
    <div class="ibox">
      <div class="ibox-body">
        <div class="flexbox mb-5">
          <div class="iboxcontent">
            <h3>User activity report</h3>
          </div>
          <div class="input-group-icon input-group-icon-left">
            <div class="commonBtn2 filter" (click)="openModal(Filter)">
              <div class="redDot" *ngIf="show == 1"></div>
              <img src="../../../../../../../assets/images/filter-filled-tool-symbol-svgrepo-com.svg">
            </div>

          </div>
        </div>
        <!-- stats -->
        <div class="row">
          <div class="col-lg-3 col-md-6">
            <div class="card">
              <div class="card-body flexbox-b">
                <div class="easypie mr-3">
                  <span class="easypie-data pd-set" style="font-size:28px;"><i><img
                        src="../../../../../../../../assets/images/ic_inventory.svg"></i></span>
                </div>
                <div>
                  <div class="text-muted">Total inventory used </div>
                  <h3 class="font-strong"> {{allData?.totalInvetoryUsed}} <small>of
                      {{allData?.totalInvetoryPlan}}</small> </h3>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6">
            <div class="card">
              <div class="card-body flexbox-b">
                <div class="easypie mr-3">
                  <span class="easypie-data pd-set" style="font-size:28px;"><i><img
                        src="../../../../assets/images/ic_email_sent.svg"></i></span>
                </div>
                <div>
                  <div class="text-muted"> Emails sent </div>
                  <h3 class="font-strong">{{allData?.emailsSent}} </h3>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6">
            <div class="card">
              <div class="card-body flexbox-b">
                <div class="easypie mr-3">
                  <span class="easypie-data pd-set" style="font-size:28px;"><i><img
                        src="../../../../assets/images/ic_search_black.svg"></i></span>
                </div>
                <div>
                  <div class="text-muted"> Total searches</div>
                  <h3 class="font-strong"> {{allData?.totalSearches}} </h3>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="card">
              <div class="card-body flexbox-b">
                <div class="easypie mr-3">
                  <span class="easypie-data pd-set" style="font-size:28px;"><i><img
                        src="../../../../assets/images/ic_candidate.svg"></i></span>
                </div>
                <div>
                  <div class="text-muted"> Candidate clicks </div>
                  <h3 class="font-strong"> {{allData?.candidateClicks}} </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- 1 -->
          <div class="col-md-12">
            <div class="ibox nventory-chart">
              <div class="ibox-head">
                <div class="ibox-title mb-2"> Inventory used by month </div>
                <a href="javascript:void(0);" class="downloadBtn" (click)="downloadCsv()">Download Report</a>
              </div>
              <div class="ibox-body userActivity" style="padding-top: 0px;">
                <!-- Table -->
                <div class="table-scroll table-wrapper user-top table-responsive">
                  <table id="example" class="table table-bordered table-hover m-0  " style="width: 100%;">
                    <thead>
                      <tr>
                        <th>Full Name</th>
                        <th>Email ID</th>
                        <th>Inventory Used</th>
                        <th>Resume View</th>
                        <th>Forward Resume </th>
                        <th>Download Resume </th>
                        <th>Send Direct Email</th>
                        <th>Total Searches</th>
                        <th>Email Opened</th>
                        <th>Candidate Clicks</th>
                        <th>Emails Open Rate</th>
                        <th>Candidate Click Rate</th>
                      </tr>
                    </thead>

                    <tbody>
                      <!-- 1 -->
                      <tr
                        *ngFor="let data of allData?.list | paginate: { id:'pagination', itemsPerPage: pagination.limit, currentPage: currentPage ,totalItems: pagination.totalItems};let i=index">
                        <td><a>{{data?.recruiterDetails?.name|| "-"}} <img src="../../../../assets/images/linkedin.png"
                              *ngIf="data?.recruiterDetails?.linkedInLink != null"
                              style="width:22px;margin-left: 5px;" /></a></td>
                        <td><a style="text-transform:unset">{{data?.recruiterDetails?.email|| "-"}} </a></td>
                        <td><a>{{data?.inventoryUsed|| "0"}}</a></td>
                        <td><a>{{data?.resumeView|| "0"}}</a></td>
                        <td><a>{{data?.forwardResume|| "0"}}</a></td>
                        <td><a>{{data?.downloadResume|| "0"}}</a></td>
                        <td><a>{{data?.sentDirectEmail|| "0"}}</a></td>
                        <td><a>{{data?.searches|| "0"}}</a></td>
                        <td><a>{{data?.emailOpen|| "0"}}</a></td>
                        <td><a>{{data.candidateClicks|| "0"}}</a></td>
                        <td><a>{{(data?.emailOpen/data?.sentDirectEmail)*100 > 0
                            ?(data?.emailOpen/data?.sentDirectEmail)*100 : "0"}} %</a></td>
                        <td><a>{{(data?.candidateClicks/allData?.totalInvetoryPlan)*100 > 0 ?
                            (data?.candidateClicks/allData?.totalInvetoryPlan)*100 : "0"}} %</a></td>
                        <!-- <td><a>{{data.candidateClicksRate | number : '1.2-2' }} %</a></td>   -->
                      </tr>
                    </tbody>
                  </table>
                  <div class="noDataFound" *ngIf="allData?.list == 0">
                    <h2>No Records Found</h2>
                  </div>
                </div>
                <!-- end -->
                <!--  pagination  -->
                <div class="col-sm-12 p-0" *ngIf="allData?.list > 0">
                  <ul class="pagination ">
                    <pagination-controls id="pagination" (pageChange)="pageChanged($event)" previousText="&#60;"
                      nextText="Next" firstText="&#62;" lastText="Last"></pagination-controls>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Filter -->
<ng-template #Filter let-modal>
  <div class="modal-body">
    <h4 class="pageTitle upper">Filter</h4>
    <form [formGroup]="filterForm">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Start Date<i class="text-danger">*</i></label>
            <input formControlName="startDate" type="text" placeholder="Select Start Date" class="form-control"
              bsDatepicker [bsConfig]="{
                isAnimated: true,
                dateInputFormat: 'DD-MM-YYYY',
                showWeekNumbers: false
              }" [maxDate]="today" />
            <div class="text-danger" *ngIf="
                filterForm.controls['startDate'].hasError('required') &&
                showError
              ">
              *Please enter valid date.
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label>End Date<i class="text-danger">*</i></label>
            <input formControlName="endDate" type="text" placeholder="Select End Date" class="form-control" bsDatepicker
              [bsConfig]="{
                isAnimated: true,
                dateInputFormat: 'DD-MM-YYYY',
                showWeekNumbers: false
              }" [maxDate]="today" />
            <div class="text-danger" *ngIf="
                filterForm.controls['endDate'].hasError('required') && showError
              ">
              *Please enter valid date.
            </div>
            <div class="text-danger" *ngIf="invalidDateFilter">
              *End Date should always be greater than Start Date.
            </div>
          </div>
        </div>
      </div>

      <div class="form-group text-right">
        <a href="javascript:void(0);" class="planbtn greyBtn" (click)="clearFilter(modal);modalRef?.hide()">Clear</a>
        <input type="submit" value="Apply" class="planbtn fill" (click)="applyFilter(modal)">
      </div>
    </form>
  </div>
</ng-template>